import { useEffect } from 'react';

const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
        xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
        xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9
        http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">

  <url>
    <loc>https://www.bioetiket.com/</loc>
    <lastmod>2025-07-14</lastmod>
    <changefreq>weekly</changefreq>
    <priority>1.0</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog</loc>
    <lastmod>2025-07-14</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/gida-etiketi-zorunlu-bilgiler</loc>
    <lastmod>2025-02-20</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.85</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/etiket-malzeme-secimi</loc>
    <lastmod>2025-01-15</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.85</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/dijital-vs-flekso-baski</loc>
    <lastmod>2025-01-08</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.85</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/umraniye-etiket-basim-hizmetleri</loc>
    <lastmod>2024-08-05</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.80</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/yukari-dudullu-etiket-baski</loc>
    <lastmod>2024-07-28</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.80</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/atasehir-isletmeleri-etiket-cozumleri</loc>
    <lastmod>2024-07-20</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.80</priority>
  </url>

  <url>
    <loc>https://www.bioetiket.com/blog/kozmetik-etiket-baskisi-bioetiket</loc>
    <lastmod>2024-07-15</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.80</priority>
  </url>

</urlset>`;

export default function SitemapXml() {
  useEffect(() => {
    document.title = 'sitemap.xml';
  }, []);

  return (
    <pre
      style={{
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        padding: '16px',
        margin: 0,
        background: '#fff',
        color: '#000',
        fontSize: '14px',
        lineHeight: '1.6',
      }}
    >
      {sitemapContent}
    </pre>
  );
}
